import { render, staticRenderFns } from "./ztxx.vue?vue&type=template&id=4b4ec127&scoped=true"
import script from "./ztxx.vue?vue&type=script&lang=js"
export * from "./ztxx.vue?vue&type=script&lang=js"
import style0 from "./ztxx.vue?vue&type=style&index=0&id=4b4ec127&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4ec127",
  null
  
)

export default component.exports